<div
  *ngIf="showModal"
  id="registerModal"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex justify-center items-start z-50 overflow-y-auto"
  (click)="emitHideModal()"
>
  <div
    class="relative card_color rounded-lg max-w-md w-full flex flex-col md:flex-row text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <button
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="emitHideModal()"
    >
      &times;
    </button>

    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-center card_color rounded-b-lg md:rounded-r-lg md:rounded-bl-none"
    >
      <div class="mb-4">
        <img
          [src]="logo ? logo : 'assets/images/no-photo-available.png'"
          alt="Logo"
          class="mx-auto object-contain"
          style="width: 200px; height: 60px"
        />
      </div>

      <h2 class="text-xl sm:text-2xl font-medium mb-4 sm:mb-6 text-left">
        Crear Cuenta
      </h2>

      <form class="space-y-4" [formGroup]="sumbmitForm">
        <div class="relative">
          <label for="username" class="block mb-2 text-sm font-medium text_gray"
            >Nombre de usuario</label
          >
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-user absolute left-3 text_color_customize"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
              <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
            </svg>
            <input
              formControlName="userName"
              maxlength="20"
              minlength="5"
              type="text"
              placeholder="nombre de usuario"
              class="text_white placeholder_gray_customize sm:text-sm border-2 rounded-lg focus_line_customize focus_line_color_customize block w-full p-3 bg_color pl-10"
            />
          </div>
          <small
            ><span
              style="color: #fc6161"
              *ngIf="
                sumbmitForm.get('userName')?.dirty &&
                sumbmitForm.get('userName')?.hasError('custom')
              "
              class="p-invalid"
              >{{ sumbmitForm.get("userName")?.getError("custom") }}</span
            ></small
          >
        </div>

        <div class="relative">
          <label
            for="loginEmail"
            class="block mb-2 text-sm font-medium text_gray"
            >Tu correo electrónico</label
          >
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-mail absolute left-3 text_color_customize"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"
              />
              <path d="M3 7l9 6l9 -6" />
            </svg>
            <input
              autocomplete="off"
              formControlName="email"
              type="text"
              class="input"
              placeholder="nombre@empresa.com"
              pInputText
              class="text_white placeholder_gray_customize sm:text-sm border-2 rounded-lg focus_line_customize focus_line_color_customize block w-full p-3 bg_color pl-10"
            />
          </div>
          <small
            ><span
              style="color: #fc6161"
              *ngIf="
                sumbmitForm.get('email')?.dirty &&
                sumbmitForm.get('email')?.hasError('custom')
              "
              class="p-invalid"
              >{{ sumbmitForm.get("email")?.getError("custom") }}</span
            ></small
          >
        </div>

        <div class="relative">
          <label
            for="registerPassword"
            class="block mb-2 text-sm font-medium text_gray"
            >Contraseña</label
          >
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-lock absolute left-3 text_color_customize"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"
              />
              <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
            </svg>
            <input
              maxlength="16"
              formControlName="password"
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="new-password"
              placeholder="••••••••"
              id="registerPassword"
              class="text_white placeholder_gray_customize sm:text-sm border-2 rounded-lg focus_line_customize focus_line_color_customize block w-full p-3 bg_color pl-10"
            />
          </div>
          <small>
            <span
              style="color: #fc6161"
              *ngIf="
                sumbmitForm.get('password')?.dirty &&
                sumbmitForm.get('password')?.hasError('custom')
              "
              class="p-invalid"
              >{{ sumbmitForm.get("password")?.getError("custom") }}</span
            ></small
          >
        </div>

        <div class="relative">
          <label
            for="confirmPassword"
            class="block mb-2 text-sm font-medium text_gray"
            >Confirmar contraseña</label
          >
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-lock absolute left-3 text_color_customize"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"
              />
              <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
            </svg>
            <input
              maxlength="16"
              formControlName="confirmPassword"
              [type]="showConfirmPassword ? 'text' : 'password'"
              autocomplete="off"
              placeholder="••••••••"
              id="confirmPassword"
              class="text_white placeholder_gray_customize sm:text-sm border-2 rounded-lg focus_line_customize focus_line_color_customize block w-full p-3 bg_color pl-10"
            />
          </div>
          <small
            ><span
              style="color: #fc6161"
              *ngIf="
                sumbmitForm.get('confirmPassword')?.dirty &&
                sumbmitForm.hasError('custom')
              "
              class="p-invalid"
              >{{ sumbmitForm.getError("custom") }}</span
            >
          </small>
        </div>

        <div class="space-y-4">
          <div class="flex items-start">
            <div class="flex items-center h-5">
              <input
                formControlName="confirmAcceptTerms"
                (change)="checkConfirmAcceptTerms()"
                id="terms"
                type="checkbox"
                class="w-4 h-4 template_color_customize border-2 rounded-lg focus_line_customize focus_line_color_customize"
                required
              />
            </div>
            <div class="ml-3 text-sm">
              <label for="terms" class="font-regular text_white dark:text_gray">
                Estoy de acuerdo con los
                <button (click)="$event.stopPropagation()">
                  <a
                    (click)="showHideTerminosyCondiciones(true)"
                    class="text_color_customize"
                  >
                    Términos y Condiciones
                  </a>
                </button>
                y
                <button (click)="$event.stopPropagation()">
                  <a
                    (click)="showHidePrivacyPolicy(true)"
                    class="text_color_customize"
                    >Políticas de Privacidad</a
                  >.
                </button>
              </label>
            </div>
          </div>
        </div>

        <button
          type="button"
          (click)="submit()"
          [disabled]="
            sumbmitForm.invalid ||
            !checkConfTerm ||
            isExistError ||
            !isValidUser ||
            !isValidMail
          "
          [class.pointer-events-none]="
            sumbmitForm.invalid ||
            !checkConfTerm ||
            isExistError ||
            !isValidUser ||
            !isValidMail
          "
          class="w-full my-2 block py-3 pointer-events-none font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg"
        >
          <div class="inline-flex items-center">Crear Cuenta</div>
        </button>
      </form>
    </div>
  </div>
</div>

<app-terminos-y-condiciones-modal
  [showTerminosyCondiciones]="showTerminosyCondiciones"
  [showPrivacyPolicy]="showPrivacyPolicy"
  (hideModal)="
    showHideTerminosyCondiciones($event); showHidePrivacyPolicy($event)
  "
></app-terminos-y-condiciones-modal>
